// Pure gameplay definitions shared by the browser and authoritative module.
import { GameConstants as C } from './constants';
import type { EntityDefinition } from './content';

export interface MapEntity {
  id: string; definition: number; x: number; y: number; offsetX: number; offsetY: number;
}

export interface PlacedEntity extends MapEntity { depleted: boolean }

export function entitySpritePosition(placement: MapEntity, definition: EntityDefinition): { x: number; y: number } {
  return {
    x: placement.x * C.tileSize + placement.offsetX - definition.anchorX,
    y: placement.y * C.tileSize + placement.offsetY - definition.anchorY,
  };
}

export function entitySortPoint(placement: MapEntity, definition: EntityDefinition): { x: number; y: number } {
  const sprite = entitySpritePosition(placement, definition);
  return { x: sprite.x + definition.sortX, y: sprite.y + definition.sortY };
}

export function entityIsSolid(placement: MapEntity, definition: EntityDefinition, depleted: boolean, tileX: number, tileY: number): boolean {
  if (depleted && definition.gather?.removeCollisionWhenDepleted) return false;
  const c = definition.collision;
  return tileX >= placement.x + c.x && tileY >= placement.y + c.y &&
    tileX < placement.x + c.x + c.width && tileY < placement.y + c.y + c.height;
}
